/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderItemDto } from './orderItemDto';
import { ContactDto } from './contactDto';
import { UserAddressDto } from './userAddressDto';
import { AdminOrderComment } from './adminOrderComment';


export interface OrderDto { 
    adminComments?: Array<AdminOrderComment>;
    comments?: string;
    contactPriorDispatch?: boolean;
    creationTimestamp?: string;
    customerAccountEmail?: string;
    deliveryAddress?: UserAddressDto;
    deliverySameAsInvoiceAddress?: boolean;
    displayInformationalDatepickers?: boolean;
    eInvoicing?: boolean;
    fakturaId?: string;
    id?: string;
    invoiceAddress?: UserAddressDto;
    mainContact?: ContactDto;
    offerNumber?: string;
    orderItems?: Array<OrderItemDto>;
    organisationNumber?: number;
    paymentMethod?: OrderDto.PaymentMethodEnum;
    pickUpOrder?: boolean;
    purchaseOrderNo?: string;
    secondaryContact?: ContactDto;
    status?: OrderDto.StatusEnum;
    updateTimestamp?: string;
    useOldIridiumPlans?: boolean;
}
export namespace OrderDto {
    export const PaymentMethodEnum = {
        BankWireTransfer: 'bank_wire_transfer',
        Check: 'check',
        CreditCard: 'credit_card',
        PurchaseOrder: 'purchase_order'
    } as const;
    export type PaymentMethodEnum = typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];
    export const StatusEnum = {
        Created: 'CREATED',
        AssignedToCustomer: 'ASSIGNED_TO_CUSTOMER',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED',
        All: 'ALL',
        AllUnresolved: 'ALL_UNRESOLVED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


export type PaymentMethodEnum = typeof OrderDto.PaymentMethodEnum[keyof typeof OrderDto.PaymentMethodEnum];
export type StatusEnum = typeof OrderDto.StatusEnum[keyof typeof OrderDto.StatusEnum];
